module.exports = __webpack_public_path__ + "static/media/living-room-request-image.cdb67ce4.jpg";